import type { ReactNode } from 'react';

export const formatDate = <T extends ReactNode = string>(
  date?: Date | string | number | null,
  options?: { fallback?: T; locale?: string }
) => {
  if (!date) {
    return options?.fallback ?? '';
  }

  const locale = options?.locale ?? 'en-US';

  try {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: 'long',
    }).format(new Date(date));
  } catch {
    return options?.fallback ?? '';
  }
};

export const formatShortDate = <T extends ReactNode = string>(
  date?: Date | string | number | null,
  options?: {
    showTime?: boolean;
    showYear?: boolean;
    fallback?: T;
    longMonth?: boolean;
    locale?: string;
  }
) => {
  if (!date) {
    return options?.fallback ?? '';
  }

  const locale = options?.locale ?? 'en-US';

  try {
    return new Intl.DateTimeFormat(locale, {
      year: options?.showYear ? 'numeric' : undefined,
      month: options?.longMonth ? 'long' : 'short',
      day: 'numeric',
      hour: options?.showTime ? 'numeric' : undefined,
      minute: options?.showTime ? 'numeric' : undefined,
      hour12: false,
    }).format(new Date(date));
  } catch {
    return options?.fallback ?? '';
  }
};
